export default "__VITE_ASSET__ipBegL2Y__"